import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import swal from 'sweetalert2';
import { logout } from '../actions';


const MenuItem = (props) => {
    const pathName = props.location.pathname || '';
    let userManagementItem = '';
    let beneUploadItem = '';
    let transferItem = '';
    let terminationItem = '';

    console.log(props.location.pathname, "abcd", )

    if (props.user.loggedInUser.Partner_Authority__c === 'Approver' || 
        props.user.loggedInUser.Partner_Authority__c === "Verifier") {
        userManagementItem = (
            <li className={pathName.indexOf('user-management') > -1 ? 'active' : ''}>
                <Link to="/portal/user-management" className="menu-item">
                    <i className="fa fa-user" /> Partner User
                </Link>
            </li>
        );
    }

    if (props.user.loggedInUser.Account.Partner_Type__c === 'School') {
        beneUploadItem = (
            <li className={pathName.indexOf('bene-upload') > -1 ? 'active' : ''}>
                {/*
                    <a
                        href="/portal/bene-upload"
                        onClick={(e) => {
                            e.preventDefault();
                            swal({
                                type: 'warning',
                                title: 'Under Maintenance',
                                html: `<p>The system is undergoing maintenance. We apologise for the inconvenience.</p><p>To submit applications, please email Jiayan the softcopy excel sheet at <a href="mailto:hojiayan@spmf.org.sg">hojiayan@spmf.org.sg</a>. Kindly print out the summary sheet for Principal's/VP's endorsement and mail the original signed copy to STSPMF. Thank you.</p>`,
                            })
                        }}
                        className="menu-item"
                    >
                        <i className="fa fa-upload" /> Beneficiary Upload
                    </a>
                */}
                <Link to="/portal/bene-upload" className="menu-item">
                    <i className="fa fa-upload" /> Beneficiary Upload
                </Link>
            </li>
        );
    }

    if (!(props.user.loggedInUser.Account.Partner_Type__c === 'School' || props.user.loggedInUser.Account.Partner_Type__c === 'Disbursing Agency')) {
        transferItem = (
            <li className={pathName.indexOf('transfer') > -1 ? 'active' : ''}>
                <Link to="/portal/transfer" className="menu-item">
                    <i className="fa fa-credit-card" /> Transfer
                </Link>
            </li>
        );
        terminationItem = (
            <li className={pathName.indexOf('termination') > -1 ? 'active' : ''}>
                <Link to="/portal/termination" className="menu-item">
                    <i className="fa fa-cut" /> Terminations
                </Link>
            </li>
        );
    }

    return (
        <ul className="nav" id="portalNavigation">
            <li className={props.location.pathname === '/portal' ? 'active' : ''}>
                <Link to="/portal" className="menu-item">
                    <i className="fa fa-dashboard" /> Dashboard
                </Link>
            </li>
            {
                props.user.loggedInUser.Partner_Authority__c ? (
                    <Fragment>
                        <li className={pathName.indexOf('registration') > -1 ? 'active' : ''}>
                            <Link to="/portal/registration-v2?new=true" className="menu-item">
                                <i className="fa fa-hand-paper-o" /> Beneficiary Registration
                            </Link>
                        </li>
                    </Fragment>
                ) : null
            }
            {/* <li className={pathName.indexOf('bene-search') > -1 ? 'active' : ''}>
                <Link to="/portal/bene-search" className="menu-item">
                    <i className="fa fa-search" /> Beneficiary Search
                </Link>
            </li> */}
            <li className={pathName.indexOf('application') > -1 ? 'active' : ''}>
                <Link to="/portal/applications" className="menu-item">
                    <i className="fa fa-paperclip" /> Applications
                </Link>
            </li>
            <li className={pathName.indexOf('beneficiar') > -1 ? 'active' : ''}>
                <Link to="/portal/beneficiaries" className="menu-item">
                    <i className="fa fa-users" /> Beneficiaries
                </Link>
            </li>
            <li className={pathName.indexOf('receipt') > -1 ? 'active' : ''}>
                <Link to="/portal/receipt" className="menu-item">
                    <i className="fa fa-bookmark" /> Receipts
                </Link>
            </li>
            {props.user.loggedInUser.Partner_Authority__c ?
                <Fragment>
                    <li className={pathName.indexOf('fund-request') > -1 ? 'active' : ''}>
                        <Link to="/portal/fund-request" className="menu-item">
                            <i className="fa fa-folder" />  Fund Requests
                        </Link>
                    </li>
                    {terminationItem}
                    {transferItem}
                    {beneUploadItem}
                    {userManagementItem}
                </Fragment> : null}
            <li >
                <a href={null} className="menu-item" onClick={props.logout} style={{ cursor: 'pointer', color: '#B70000' }}>
                    <i className="fa fa-sign-out" /> Logout
                </a>
            </li>
        </ul>
    );
};

MenuItem.propTypes = {
    logout: PropTypes.func.isRequired,
    location: PropTypes.object,
    authority: PropTypes.string,
    user: PropTypes.object.isRequired,
};

MenuItem.defaultProps = {
    location: {
        pathname: '',
    },
    authority: '',
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        logout,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});


export default connect(mapStateToProps, mapDispatchToProps)(MenuItem);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/common/MenuItem.js
// module id = 786
// module chunks = 0